import { addMonths, lastDayOfMonth, lastDayOfWeek } from 'date-fns';
import { addDays } from 'date-fns/esm';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
interface IParam {
    setCallback?: Function,
    events?: Array<Record<string, any>>

}

const SelecionarRegiao: React.FC<IParam> = () => {




    return <div className='gap max-600 row gap selectRegiao' style={{ justifyContent: 'center', marginTop: '20px' }}>

        <Link tabIndex={0} to={`/conteudos/categoria/norte`} onClick={() => window.scrollTo(0, 0)} className='full-width pointer' style={{ maxWidth: '18%' }}  ><img className='full-width' src="/apoio/Norte.png" /></Link>
        {/*   <Link to={`/conteudos/categoria/nordeste`} onClick={() => window.scrollTo(0, 0)} className='full-width' style={{ maxWidth: '20%' }}  ><img className='full-width' src="/apoio/Nordeste.png" /></Link>
        <Link to={`/conteudos/categoria/centro-oeste`} onClick={() => window.scrollTo(0, 0)} className='full-width' style={{ maxWidth: '18%' }} ><img className='full-width' src="/apoio/Centro-oeste.png" /></Link>
        <Link to={`/conteudos/categoria/sudeste`} onClick={() => window.scrollTo(0, 0)} className='full-width' style={{ maxWidth: '20%' }}  ><img className='full-width' src="/apoio/Sudeste.png" /></Link>
<Link to={`/conteudos/categoria/sul`} onClick={() => window.scrollTo(0, 0)} className='full-width' style={{ maxWidth: '13%' }}  ><img className='full-width' src="/apoio/Sul.png" /></Link> */}
        <Link tabIndex={0} to={`/conteudos/categoria/nordeste`} onClick={() => window.scrollTo(0, 0)} className='full-width' style={{ maxWidth: '20%' }}  ><img className='full-width' src="/apoio/Nordeste.png" /></Link>

        <div style={{ position: 'relative' }}> <nav className='full-width' style={{ opacity: '0.3' }} ><img style={{ width: '80%' }} src="/apoio/Centro-oeste.png" /></nav></div>
        <div style={{ position: 'relative' }}>  <nav className='full-width' style={{ opacity: '0.3' }}  ><img style={{ width: '90%' }} src="/apoio/Sudeste.png" /></nav></div>
        <div style={{ position: 'relative' }}>  <nav className='full-width' style={{ opacity: '0.3' }}  ><img style={{ width: '70%' }} src="/apoio/Sul.png" /></nav></div>
    </div >


}

export default SelecionarRegiao;